import { Property } from '@ncss/models/dist/v3';
import { computed } from 'vue';

const BucketRoot = `https://property-uploader-us-west-1.s3.us-west-1.amazonaws.com`;

export function usePropertyPhotos(getProp: () => Property | undefined | null) {
  const photos = computed(() => {
    const prop = getProp();
    if (prop) {
      return prop.docs
        ?.filter((d) => /img|image/i.test(d.type))
        .map((p) => {
          if (!p.url) {
            // compute object url if it doesn't exist. In the past we use to not store the URL on the document itself
            const pId = prop._id.replace('p_', '');
            p.url = `${BucketRoot}/${pId}/${encodeURIComponent(p.name)}`;
          }
          return p;
        });
    } else {
      return [];
    }
  });

  return { photos };
}

export function usePropertyDocs(getProp: () => Property | undefined | null) {
  const docs = computed(() => {
    const prop = getProp();
    if (prop) {
      return prop.docs
        ?.filter((d) => !/img|image/i.test(d.type))
        .map((d) => {
          if (!d.url) {
            const pId = prop._id.replace('p_', '');
            d.url = `${BucketRoot}/${pId}/${encodeURIComponent(d.name)}`;
          }
          return d;
        });
    } else {
      return [];
    }
  });

  return { docs };
}
